export default "__VITE_ASSET__CgLLRwsg__"